import { PropsWithChildren } from 'react';

import {
  GlobalHeader,
  PageLayout,
  type PageLayoutProps,
} from '@/app/components/layout';

interface Props {
  readonly pageName: PageLayoutProps['pageName'];
}

const EssencePageLayout = ({
  children,
  pageName,
}: PropsWithChildren<Props>) => {
  return (
    <PageLayout
      hideSocialLinks
      name="Essence Enrollment Order Portal"
      pageName={pageName}
    >
      <GlobalHeader />
      {children}
    </PageLayout>
  );
};

export default EssencePageLayout;
